module.exports = __webpack_public_path__ + "img/max-file-check--xml.dd70bc72.svg";